import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootStates } from 'redux/store';
import { apiUrl } from '../../constants/paths';

export const checklistApi = createApi({
  reducerPath: 'checklistApi',
  refetchOnReconnect: true,
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootStates).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    createNewChecklistLibrary: build.mutation({
      query: (body) => ({
        url: apiUrl.checklistLibrary,
        method: 'POST',
        body: body,
      }),
    }),
    createNewChecklist: build.mutation({
      query: (body) => ({
        url: apiUrl.checklists,
        method: 'POST',
        body,
      }),
    }),
    updateChecklists: build.mutation({
      query: (body) => ({
        url: apiUrl.checklistLibrary + `/${body.libId}`,
        method: 'PATCH',
        body: body.values,
      }),
    }),
    deleteChecklistsLibrary: build.mutation({
      query: (id) => ({
        url: apiUrl.checklistLibrary + `/${id}`,
        method: 'DELETE',
      }),
    }),
    deleteSingleChecklists: build.mutation({
      query: (params) => ({
        url: apiUrl.checklists + `/${params.checklistId}`,
        method: 'DELETE',
      }),
    }),
    getChecklists: build.mutation({
      query: () => ({
        url: '/users/checklists',
        method: 'GET',
      }),
    }),
    getProjectChecklists: build.mutation({
      query: (projectId) => ({
        url: `/users/projects/${projectId}/checklists-library`,
        method: 'GET',
      }),
    }),
    getChecklistsByProjectId: build.mutation({
      query: (projectId) => ({
        url: `${apiUrl.project}/${projectId}/checklists`,
        method: 'GET',
      }),
    }),
    getChecklistsByLibId: build.mutation({
      query: (params) => ({
        url: `/users/checklists/${params.checklistId}`,
        method: 'GET',
      }),
    }),
    updateChecklistsByLibId: build.mutation({
      query: (params) => ({
        url: `${apiUrl.checklists}/${params.checklistId}`,
        method: 'PATCH',
        body: params.body,
      }),
    }),
  }),
});

export const {
  useCreateNewChecklistLibraryMutation,
  useCreateNewChecklistMutation,
  useUpdateChecklistsMutation,
  useGetChecklistsMutation,
  useGetProjectChecklistsMutation,
  useDeleteChecklistsLibraryMutation,
  useDeleteSingleChecklistsMutation,
  useGetChecklistsByLibIdMutation,
  useUpdateChecklistsByLibIdMutation,
  useGetChecklistsByProjectIdMutation,
} = checklistApi;
